/**
 * Model to hold organization resource data from identity
 */
export class IdentityOrganization {
    public static ID_USA_WRESTLING: string = 'a79b8daf-1df5-4298-83bd-4a99f2c99ef8';
    public static ID_TRACKWRESTLING: string = 'fdaab43d-b34b-4577-9b41-21d5bb779e2b';

    public id: string = null;
    public longName: string = null;
    public shortName: string = null;
    public hasModifyAccess: boolean;

    constructor(id: string = null) {
        this.id = id;
    }

    public formatName(): string {
        if (this.longName && this.shortName) {
            return `${this.longName} (${this.shortName})`;
        }

        return this.longName || this.shortName || '';
    }

    public clone(): IdentityOrganization {
        const clone: IdentityOrganization = new IdentityOrganization();
        clone.id = this.id;
        clone.longName = this.longName;
        clone.shortName = this.shortName;
        clone.hasModifyAccess = this.hasModifyAccess;

        return clone;
    }

    /**
     * Serialize to a json api format
     */
    public serialize(): string {
        const json: any = {};
        json.data = {};
        json.data.type = 'organization';
        json.data.id = this.id;
        json.data.attributes = {};
        json.data.attributes.longName = this.longName;
        json.data.attributes.shortName = this.shortName;

        return JSON.stringify(json);
    }

    /**
     * Deserialize from json api format
     */
    public deserialize(json: any): IdentityOrganization {
        const data: any = json['data'] || json;
        const attrs: any = data['attributes'];
        const meta: any = json['meta'];

        this.id = data.id;
        this.longName = attrs.longName;
        this.shortName = attrs.shortName;

        if (meta && meta['userPermissions']) {
            this.hasModifyAccess = meta['userPermissions']['hasModifyAccess'];
        }

        return this;
    }
}
